import ApplicationSerializer from './ApplicationSerializer';
import { configurePaginatedSerializer } from './utils';

const PaginatedApplicationSerializer = configurePaginatedSerializer({
  baseSerializer: ApplicationSerializer,
});

export default {
  application: ApplicationSerializer,
  paginatedResource: PaginatedApplicationSerializer,
};
